// This is UI flow state, not a replacement for server-side authorization.
const KEY = 'hccm-login-security';
export const SECURITY_EVENT = 'hccm-security-session-changed';
type LoginState = {
  token: string;
  smsVerified?: boolean;
  smsExpiresAt?: number;
  reminderSeen?: boolean;
};
export function readLoginState(token: string): LoginState {
  try {
    const state = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return state?.token === token ? state : { token };
  } catch {
    return { token };
  }
}
export function updateLoginState(token: string, patch: Partial<LoginState>) {
  sessionStorage.setItem(KEY, JSON.stringify({ ...readLoginState(token), ...patch, token }));
}
export function clearLoginState() {
  sessionStorage.removeItem(KEY);
  window.dispatchEvent(new Event(SECURITY_EVENT));
}
